import { Typography, Card, CardContent, CardActionArea } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { User } from "../models";
import React from "react";
import { UserContext } from "../hooks/UserContext";

interface LandingPageProps {
	setLoggedIn: (user: User) => void;
}

// oxlint-disable-next-line no-unused-vars
export default function HomePage(props: LandingPageProps) {
	const navigate = useNavigate();
	const userContext = React.useContext(UserContext) as User | undefined;

	function linkCard(url: string, title: string) {
		return (
			<Grid size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
				<Card className="home-card">
					<CardActionArea
						onClick={() => {
							navigate(url);
						}}
					>
						<CardContent>
							<Typography variant="h6">{title}</Typography>
						</CardContent>
					</CardActionArea>
				</Card>
			</Grid>
		);
	}

	return (
		<>
			<Grid container spacing={2} className="home-grid">
				{linkCard("/jobs/dashboard", "Jobs Dashboard")}
				{linkCard("/jobs/submit", "Submit Jobs")}
				{linkCard("/jobs/ready", "Mark Jobs Ready")}
				{userContext?.isAdmin && linkCard("/admin/sortshp", "Reorganize Shapefiles")}
				{userContext?.isAdmin && linkCard("/admin/import", "Import Settings")}
				{userContext?.isAdmin && linkCard("/admin/mission-control-logs", "Mission Control Logs")}
				{userContext?.isAdmin && linkCard("/admin/mission-control-passwords-generator", "Mission Control Passwords")}
				{userContext?.isAdmin && linkCard("/admin/password-generator", "Rogo Login Generator")}
			</Grid>
		</>
	);
}
